import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { LineChart, Line, Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Text, Tooltip, XAxis, YAxis, ReferenceArea } from 'recharts';
import { getUniqueKeys, getUniqueValues, subsetData } from '../../utils/utils';

import { setChartData } from '../../redux/chartDataSlice';
import { setWeek } from '../../redux/chooseWeekSlice';



const TimeLineChart = () => {
    const dispatch = useDispatch()

    const data = useSelector(state => state.rawData.value)
    const dateData = useSelector(state => state.dateData.value)
    const selectedItems = useSelector(state => state.chooseItem.value)
    const chartData = useSelector(state => state.chartData.value)

    const [ localChartData, setLocalChartData ] = useState({})
    const selectedDates = useSelector(state => state.chooseWeek.value)

    const chartFontStyle = {
        fontFamily: 'Roboto',
        fontWeight: 'bold'
    }

    const sortDates = (currentDate, newDate) => {
        const cd = new Date(currentDate).getTime()
        const nd = new Date(newDate).getTime()
        if (nd < cd) {
            return newDate
        } 
        return currentDate
    }

    const findStock = (item) => {
        const stock = data.find((article) => {
            return article.TARIEFOMSCHRIJVING == item
        })
        return stock.VRIJEVOORRAAD
    }


    useEffect(() => {
        const today = new Date()
        today.setHours(0,0,0,0)
        const start = selectedDates.from
        const end = selectedDates.to

        const getDaysArray = (s,e) => {for(var a=[],d=new Date(s);d<=new Date(e);d.setDate(d.getDate()+1)){ a.push(new Date(d));}return a;};

        // const days is an object with the dates as keys and the values are 0
        const days = getDaysArray(today, end)

        const temp = []

        // for each day in the selected range, create an object with the date and the stock of each item
        days.forEach((day) => {
            const obj = {date:day}
            Object.keys(selectedItems).forEach((ig) => {
                Object.keys(selectedItems[ig]).forEach((item) => {
                    if (selectedItems[ig][item] === true){
                        obj[item] = 0
                    }
                })
            })
            temp.push(obj)
        })


        // for each item in the list, add the tariefomschrijving as key with a value of 0
        Object.keys(selectedItems).forEach((ig) => {
            Object.keys(selectedItems[ig]).forEach((item) => {
                if (selectedItems[ig][item] === true){
                    temp.forEach((day) => {
                        day[item] = 0
                    })
                }
            })
        })


        // add the stock of the current date to the current date
        Object.keys(selectedItems).forEach((ig) => {
            Object.keys(selectedItems[ig]).forEach((item) => {
                if (selectedItems[ig][item] === true){
                    const newValue = findStock(item)
                    temp.forEach((day) => {
                        if (day.date.getTime() == today.getTime()){
                            day[item] = newValue
                        }
                    })
                }
            })
        })


        // for every date in temp, copy the stock of the previous date, then subtract the aantal from dateDate from the stock
        temp.forEach((day, index) => {
            if (index > 0){
                Object.keys(day).forEach((item) => {
                    if (item != 'date'){
                        day[item] = temp[index-1][item]
                    }
                })
            }

            dateData.forEach((project) => {
                
                const pd = new Date(project.datum)
                pd.setHours(0,0,0,0)

                const dd = day.date
                dd.setHours(0,0,0,0)

                if (pd.getTime() == dd.getTime()){
                    if (day[project.tariefomschrijving] != null && day[project.tariefomschrijving] != undefined){
                        day[project.tariefomschrijving] -= project.aantal
                    }
                }
            })
        })

        // console.log(JSON.stringify(temp))


// 

        // remove all dates before the start date
        const temp2 = []
        temp.forEach((day, index) => {
            if (day.date.getTime() >= start){
                temp2.push(day)
            }
        })
        
        setLocalChartData(temp2)

    }, [selectedItems, selectedDates, data, dateData] )

    useEffect(() => {
        if (localChartData.keys != null){
            const temp = [...localChartData]
            if (!Number.isInteger (temp[0].date)){
                temp.forEach((day) => {
                    day.date = day.date.getTime()
                })
            } 
            dispatch(setChartData(temp))
        }
    }, [localChartData])



    
    const formatAxis = (tick) => {
        const ticker = new Date(tick)
        return ticker.getDate() + '-' + (ticker.getMonth() + 1) + '-' + ticker.getFullYear()
    }

    const formatTooltip = (value) => {
        const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        return new Date(value).toLocaleDateString('nl-NL', options)

    }

    const findLowest = () => {
        let lowest = 0
        localChartData.forEach((day) => {
            Object.keys(day).forEach((item) => {
                if (item != 'date'){
                    if (day[item] < lowest){
                        lowest = day[item]
                    }
                }
            })
        })
        //  round lowest down to the nearest 5
        return lowest
    }
  
    const [zoom, setZoom] = useState({
        leftRef: null,
        rightRef: null,
    })
    const [clicked, setClicked] = useState(false)

    const pauseEvent = (e) => {
        if (e.stopPropagation) e.stopPropagation();
        if (e.preventDefault) e.preventDefault();
        e.cancelBubble=true;
        e.returnValue=false;
        return false;
    }
    
    const handleOnMouseDown = (e) => {
        pauseEvent(e)
        setZoom( {...zoom, leftRef: e.activeLabel} )
        setClicked(true)
    }

    const handleOnMouseMove = (e) => {
        pauseEvent(e)
        if (clicked){
            if (zoom.leftRef != null){
                setZoom( {...zoom, rightRef: e.activeLabel} )
            }
        }
    }

    const handleOnMouseUp = (e) => {
        pauseEvent(e)
        setClicked(false)

        if (zoom.leftRef != null && zoom.rightRef != null){
            if (zoom.leftRef < zoom.rightRef){
                dispatch(setWeek({from: zoom.leftRef, to: zoom.rightRef}))
                setZoom({leftRef: null, rightRef: null})
            } else {
                dispatch(setWeek({from : zoom.rightRef, to: zoom.leftRef}))
                setZoom({leftRef: null, rightRef: null})
            }
        } else {
            setZoom({leftRef: null, rightRef: null})
        }
    }
   


    
    return (
    <Box>
        <ResponsiveContainer width="100%" aspect={6/3}>
            <LineChart 
                width={400} 
                height={400} 
                data={ localChartData }
                onMouseDown={(e) => handleOnMouseDown(e)}
                onMouseMove={(e) => handleOnMouseMove(e)}
                onMouseUp={(e) => {handleOnMouseUp(e)}}
            >
                { localChartData.keys != null &&
                Object.keys(localChartData[0]).map((item, key) => {
                    const randomColor = "#" + ((1 << 24) * Math.random() | 0).toString(16).padStart(6, "0")
                    if (item != 'date'){
                        return <Line key={key} type="monotone" dataKey={item} stroke={randomColor} animationDuration={300}/>
                    }
                    })
                }
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis 
                    dataKey="date" 
                    tickFormatter={formatAxis}
                    angle={-45}
                    height={70}
                    textAnchor="end"
                />
                <YAxis type="number" domain={['dataMin', 'dataMax']} />
                <Tooltip 
                       itemSorter={(item) => {
                        return Number(item.value) * -1;
                     }}
                    labelFormatter={formatTooltip}
                    labelStyle={{
                        fontWeight: 'bold',
                        borderBottom: '1px solid black',
                        paddingBottom: '5px',
                    }}
                    allowEscapeViewBox={{x: false, y: true}}
                    animationDuration={200}
                    contentStyle={{
                        borderRadius: '10px',
                        border: 'none',
                        boxShadow: '0 5px 16px rgba(0, 0, 0, 0.2)',
                        textAlign: 'left',
                        fontFamily: chartFontStyle.fontFamily,
                        fontSize: chartFontStyle.fontSize,
                    }}
                />
                { localChartData.keys != null &&
                    <ReferenceArea y1={0} y2={findLowest()} strokeOpacity={0} />
                }
                {zoom.leftRef != null && zoom.rightRef != null ? <ReferenceArea x1={zoom.leftRef} x2={zoom.rightRef} strokeOpacity={0} /> : null}
            </LineChart>
        </ResponsiveContainer>

    </Box>
    )
}

export default TimeLineChart